import _ from 'lodash';
import portausUtil from '@/utils/portaus-utils.js'

const companyCustomerPhoneNumber = (state) => {
  if(state.company!=null &&
    state.company.phone!=null &&
    state.company.phone.length<=4)return state.company.phone;
  return portausUtil.getFormattedPhoneNumber(state.company.phone);
}


const individualCustomerPhoneNumber = (state) => {
  if(state.contact!=null &&
    state.contact.phone!=null &&
    state.contact.phone.length<=4)return state.contact.phone;
  return portausUtil.getFormattedPhoneNumber(state.contact.phone);
}

const isCompany = (state) => {
  return state.type=='1';
}

const isIndividual = (state) => {
  return state.type=='0';
}

const getInvoiceReminderNotification = (state) =>{
  let invoice_reminder = [];
  _.forEach(state.notifications, n=>{
    if(n.type=="INVOICE_REMINDER"){
      invoice_reminder.push(n);
    }
  })
  return invoice_reminder;
}

export default {
  companyCustomerPhoneNumber,
  individualCustomerPhoneNumber,
  isCompany,
  isIndividual,
  getInvoiceReminderNotification
};
